/**
 * Returns url and param string concatination
 * with correct symbol in between
 * @param {string} url initial URL string
 * @param {string} params string of params to append
 * @return {string} concatinated url string
 */
export function appendParamString(url, params) {
    if (url.indexOf('?') >= 0) {
        return `${url}&${params}`;
    }

    return `${url}?${params}`;
}

export default appendParamString;
